import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetsLockerLinkComponent } from './access-locker-link/assets-locker-link.component';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUtilsCookiesModule } from '@usheru-hff/shared/utils-cookies';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { RouterModule } from '@angular/router';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUiStreamingLogoFallbackModule } from '@usheru-hff/shared/ui-streaming-logo-fallback';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SharedUiPictureModule,
    FontAwesomeModule,
    SharedUtilsCookiesModule,
    SharedUtilsTranslationModule,
    SharedUtilsImageModule,
    SharedUtilsModule,
    SharedUiStreamingLogoFallbackModule,
    LoadingIndicatorComponent,
    SharedUtilsTranslationModule
  ],
  declarations: [AssetsLockerLinkComponent],
  exports: [AssetsLockerLinkComponent]
})
export class AssetsLockerUiAccessLinkModule {}
